export const CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR = 'src/component/RiskFactor/OverriddingRiskFactor/create/Create_Automated_Overridding_Riskfactor';
export const CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR_SUCCESSFULL = 'src/component/RiskFactor/OverriddingRiskFactor/create/Create_Automated_Overridding_Riskfactor_Successfull';
export const CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR_FAILURE = 'src/component/RiskFactor/OverriddingRiskFactor/create/Create_Automated_Overridding_Riskfactor_Failure';

export const createAutomatedOverriddingRiskFactor = (data) => {
    return {
        type: CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR,
        data
    }
}
export const createAutomatedOverriddingRiskFactorSuccess = (data) => {
    return {
        type: CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR_SUCCESSFULL,
        data
    }
}
export const createAutomatedOverriddingRiskFactorFailure = (data) => {
    return {
        type: CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR_FAILURE,
        data
    }
}

export const FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS = 'src/component/RiskFactor/OverriddingRiskFactor/create/Fetch_Automated_Overridding_Riskfactor_Details';
export const FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS_SUCCESS = 'src/component/RiskFactor/OverriddingRiskFactor/create/Fetch_Automated_Overridding_Riskfactor_Details_Success';
export const FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS_FAILURE = 'src/component/RiskFactor/OverriddingRiskFactor/create/Fetch_Automated_Overridding_Riskfactor_Details_Failure';

export const automatedOveriddingRiskFactorDetails = (data) => {
    return {
        type: FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS,
        data
    }
}
export const automatedOveriddingRiskFactorDetailsSuccess = (data) => {
    return {
        type: FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS_SUCCESS,
        data
    }
}
export const automatedOveriddingRiskFactorDetailsFailure = (data) => {
    return {
        type: FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS_FAILURE,
        data
    }
}

export const EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR = 'src/component/RiskFactor/OverriddingRiskFactor/create/Edit_Automated_Overridding_Riskfactor';
export const EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR_SUCCESSFULL = 'src/component/RiskFactor/OverriddingRiskFactor/create/Edit_Automated_Overridding_Riskfactor_Successfull';
export const EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR_FAILURE = 'src/component/RiskFactor/OverriddingRiskFactor/create/Edit_Automated_Overridding_Riskfactor_Failure';

export const editAutomatedOverriddingRiskFactor = (data) => {
    return {
        type: EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR,
        data
    }
}
export const editAutomatedOverriddingRiskFactorSuccess = (data) => {
    return {
        type: EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR_SUCCESSFULL,
        data
    }
}
export const editAutomatedOverriddingRiskFactorFailure = (data) => {
    return {
        type: EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR_FAILURE,
        data
    }
}